(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('BillingReportsMainController', MainController);

	// AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
	MainController.$inject = [ '$scope', '$state' ];

	function MainController($scope, $state) {

		$scope.tabData = [ {
			heading : 'Authorization Fee Summary-NON-NCTC',
            route : 'billing-reports-main.nonnctc',
            class: 'btn-lg'

		}, {
			heading : 'Authorization Fee Summary-NCTC',
			route : 'billing-reports-main.nctc',
            class: 'btn-lg'
		}, {
			heading : 'Authorization Fee Summary-DTA',
            route : 'billing-reports-main.dta',
            class: 'btn-lg'
		}, {
			heading : 'Revenue Summary',
			route : 'billing-reports-main.revenue',
            class: 'btn-lg'
		} ];

		$scope.go = function(route) {
		};
	}

})();
